import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { fetchPrograms, selectAllPrograms } from 'state/Programs/programsSlice';
import { useAppThunkDispatch } from 'state/store';
import { Program } from 'utils/customTypes';

interface UseProjectProgramsReturn {
  programs: Program[];
  fetchProjectPrograms: () => Promise<void>;
}

export const useProjectPrograms = (): UseProjectProgramsReturn => {
  const dispatch = useAppThunkDispatch();
  const programs = useSelector(selectAllPrograms);

  const fetchProjectPrograms = useCallback(async () => {
    await dispatch(fetchPrograms());
  }, [dispatch]);

  return useMemo(
    () => ({ programs, fetchProjectPrograms }),
    [programs, fetchProjectPrograms]
  );
};
